app.controller('navigationController', function ($rootScope, $scope, $filter, $http, $window, $routeParams, $location) {

  const routeURL = `/${$routeParams.cad_code}/${$routeParams.appeal_id}/${$routeParams.user_id}/${$routeParams.token}/`
  
  $scope.changeRoute = (route) => { 
    console.log('*******routeURL + route :>> ', routeURL + route);
    $location.path(routeURL + route)
  }

  $scope.returnToDashboard = () => { 
    if ($rootScope.close_only) {
      $window.close()
      return
    } else {
      const returnURL       = `https://dashboard.propertytax.io/${$routeParams.user_id}/${$routeParams.token}`
      $window.location.href = returnURL
    }
  }

})